import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

function O2Table(props) {
  var children = props.children,
      className = props.className,
      middle = props.middle,
      noShadow = props.noShadow,
      wordBreak = props.wordBreak,
      condensed = props.condensed,
      fixed = props.fixed,
      striped = props.striped,
      fullText = props.fullText,
      internal = props.internal,
      loading = props.loading,
      attributes = _objectWithoutPropertiesLoose(props, ["children", "className", "middle", "noShadow", "wordBreak", "condensed", "fixed", "striped", "fullText", "internal", "loading"]);

  var classes = classNames(className, 'o2-table', {
    'o2-table--middle': middle,
    'o2-table--noshadow': noShadow,
    'o2-table--word-break': wordBreak,
    'o2-table--condensed': condensed,
    'o2-table--fixed': fixed,
    'o2-table--striped': striped,
    'o2-table--fulltext': fullText,
    'o2-table--internal': internal,
    'o2-loader--overlay': loading
  });
  return /*#__PURE__*/React.createElement("table", _extends({}, attributes, {
    className: classes
  }), children);
}

O2Table.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  middle: PropTypes.bool,
  noShadow: PropTypes.bool,
  wordBreak: PropTypes.bool,
  condensed: PropTypes.bool,
  fixed: PropTypes.bool,
  striped: PropTypes.bool,
  fullText: PropTypes.bool,
  internal: PropTypes.bool,
  loading: PropTypes.bool
};
export default O2Table;